/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DiscordConnectionIntegration } from './DiscordConnectionIntegration';
import {
    DiscordConnectionIntegrationFromJSON,
    DiscordConnectionIntegrationFromJSONTyped,
    DiscordConnectionIntegrationToJSON,
    DiscordConnectionIntegrationToJSONTyped,
} from './DiscordConnectionIntegration';

/**
 * 
 * @export
 * @interface DiscordConnection
 */
export interface DiscordConnection {
    /**
     * Platform identifier (steam, xbox, playstation, riotgames, epicgames, battlenet, twitch, bungie, leagueoflegends, roblox, etc.)
     * @type {string}
     * @memberof DiscordConnection
     */
    type?: string;
    /**
     * Platform-specific account ID
     * @type {string}
     * @memberof DiscordConnection
     */
    id?: string;
    /**
     * Display name on that platform
     * @type {string}
     * @memberof DiscordConnection
     */
    name?: string;
    /**
     * Whether Discord verified ownership of this connection
     * @type {boolean}
     * @memberof DiscordConnection
     */
    verified?: boolean;
    /**
     * Whether the connection has been revoked
     * @type {boolean}
     * @memberof DiscordConnection
     */
    revoked?: boolean;
    /**
     * Whether friend sync is enabled for this connection
     * @type {boolean}
     * @memberof DiscordConnection
     */
    friend_sync?: boolean;
    /**
     * Whether activities related to this connection show in Discord presence
     * @type {boolean}
     * @memberof DiscordConnection
     */
    show_activity?: boolean;
    /**
     * Whether this connection has a corresponding third-party OAuth2 token
     * @type {boolean}
     * @memberof DiscordConnection
     */
    two_way_link?: boolean;
    /**
     * 0 = hidden from Discord profile, 1 = visible to everyone
     * @type {number}
     * @memberof DiscordConnection
     */
    visibility?: number;
    /**
     * Partial server integrations for this connection
     * @type {Array<DiscordConnectionIntegration>}
     * @memberof DiscordConnection
     */
    integrations?: Array<DiscordConnectionIntegration>;
}

/**
 * Check if a given object implements the DiscordConnection interface.
 */
export function instanceOfDiscordConnection(value: object): value is DiscordConnection {
    return true;
}

export function DiscordConnectionFromJSON(json: any): DiscordConnection {
    return DiscordConnectionFromJSONTyped(json, false);
}

export function DiscordConnectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiscordConnection {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : json['type'],
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'verified': json['verified'] == null ? undefined : json['verified'],
        'revoked': json['revoked'] == null ? undefined : json['revoked'],
        'friend_sync': json['friend_sync'] == null ? undefined : json['friend_sync'],
        'show_activity': json['show_activity'] == null ? undefined : json['show_activity'],
        'two_way_link': json['two_way_link'] == null ? undefined : json['two_way_link'],
        'visibility': json['visibility'] == null ? undefined : json['visibility'],
        'integrations': json['integrations'] == null ? undefined : ((json['integrations'] as Array<any>).map(DiscordConnectionIntegrationFromJSON)),
    };
}

export function DiscordConnectionToJSON(json: any): DiscordConnection {
    return DiscordConnectionToJSONTyped(json, false);
}

export function DiscordConnectionToJSONTyped(value?: DiscordConnection | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'id': value['id'],
        'name': value['name'],
        'verified': value['verified'],
        'revoked': value['revoked'],
        'friend_sync': value['friend_sync'],
        'show_activity': value['show_activity'],
        'two_way_link': value['two_way_link'],
        'visibility': value['visibility'],
        'integrations': value['integrations'] == null ? undefined : ((value['integrations'] as Array<any>).map(DiscordConnectionIntegrationToJSON)),
    };
}

